'use client';

import { Containers, Widgets } from '@components';

export default function HomePage() {
    return (
        <>
            <Containers.Section el={<Widgets.HeroSection />} />
            <Containers.Section el={<Widgets.HeroOvalDivider />} />
            <Containers.Section el={<Widgets.BuildIchra />} />
            <Containers.Section el={<Widgets.TurnKey />} />
            <Containers.Section el={<Widgets.IchraSolution />} />
            <Containers.Section el={<Widgets.WhyWeStarted />} />
            <Containers.Section el={<Widgets.ReadToBuild />} />
        </>
    );
}
